import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { IMG, HERO, FACTS, WHY, WHY_INTRO, STEPS, MENTIONED_WORK, PRICES, PRICE_HIGHLIGHTS, PRICE_NOTE, PRICE_DEMO_LABEL, PRICES_INTRO, SERVICES_INTRO, PROJECTS_INTRO, ABOUT_HOME, PROCESS, MORE_WORK, CONTACT_CTA } from "@/lib/content";
import { Btn } from "@/components/public/ui";
import { HomeHero, Ticker, ServicesShowcase, PriceBoard, Statement, FeaturedProjects, WorkPoints, ProcessSteps, HomeCTA } from "@/components/public/HomeSections";

const PULSE_REFRESH_MS = 60_000;

export default function Home() {
  const [projects, setProjects] = useState(null);
  const [pulse, setPulse] = useState(null);

  useEffect(() => {
    api.get("/public/projects?featured=1").then((r) => setProjects(r.data)).catch(() => setProjects([]));
  }, []);

  // Live numbers from Drift. Refreshed quietly while the page is open.
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/public/pulse").then((r) => alive && setPulse(r.data)).catch(() => alive && setPulse(null));
    load();
    const id = setInterval(load, PULSE_REFRESH_MS);
    return () => { alive = false; clearInterval(id); };
  }, []);

  const highlights = PRICE_HIGHLIGHTS.map((id) => PRICES.find((p) => p.id === id)).filter(Boolean);

  return (
    <div data-testid="public-home">
      <HomeHero
        title={HERO.title}
        lead={HERO.lead}
        sub={HERO.sub}
        pulse={pulse}
        actions={
          <>
            <Btn to="/kontakt" size="lg" arrow data-testid="public-hero-bestill-button">{HERO.primary}</Btn>
            <Btn href="#tenester" variant="outline" size="lg" data-testid="public-hero-prices-button">{HERO.secondary}</Btn>
          </>
        }
      />

      <Ticker items={MENTIONED_WORK} label={MORE_WORK.title} />

      <ServicesShowcase intro={SERVICES_INTRO} />

      <PriceBoard intro={PRICES_INTRO} items={highlights} note={PRICE_NOTE} demoLabel={PRICE_DEMO_LABEL} />

      <Statement about={ABOUT_HOME} facts={FACTS} image={IMG.village} imageAlt={HERO.alt.village} />

      <FeaturedProjects intro={PROJECTS_INTRO} projects={projects} />

      <WorkPoints label={WHY_INTRO.label} title={WHY_INTRO.title} items={WHY} image={IMG.portrait_van} imageAlt={HERO.alt.van} />

      <ProcessSteps label={PROCESS.label} title={PROCESS.title} steps={STEPS} cta={PROCESS.cta} />

      <HomeCTA cta={CONTACT_CTA} />
    </div>
  );
}
